/** The dashboard's rupees and plurals, shared by both of its layouts. */

export const inr = (value) => {
  const n = Math.round(Number(value) || 0);
  const abs = Math.abs(n);
  const sign = n < 0 ? '-' : '';
  if (abs >= 1e7) return `${sign}₹${(abs / 1e7).toFixed(2)} Cr`;
  if (abs >= 1e5) return `${sign}₹${(abs / 1e5).toFixed(2)} L`;
  if (abs >= 1000) return `${sign}₹${(abs / 1000).toFixed(1)} K`;
  return `${sign}₹${abs.toLocaleString('en-IN')}`;
};

export const exact = (value) => `₹${Math.round(Number(value) || 0).toLocaleString('en-IN')}`;

export const plural = (n, word) => `${n} ${word}${n === 1 ? '' : 's'}`;
